import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72baf766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qizhongji-container" }
const _hoisted_2 = { class: "nav-bg" }
const _hoisted_3 = { class: "card-float" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "在线率", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "%", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "在场设备", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "台", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "今日告警", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次", -1))
const _hoisted_10 = { class: "list-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备编号：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作司机：", -1))
const _hoisted_14 = {
  key: 0,
  class: "bottom-text"
}
const _hoisted_15 = {
  key: 1,
  class: "bottom-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.count.percent ? _ctx.count.percent : 0), 1),
              _hoisted_5
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.count.num ? _ctx.count.num : 0), 1),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.count.warnNum ? _ctx.count.warnNum : 0), 1),
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.towerTable, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "listdata",
              onClick: ($event: any) => (_ctx.qzjDetail(item))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(item.name), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                  online: item.status === 1,
                  offline: item.status === 0,
                })
                  }, null, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass({
                  online1: item.status === 1,
                  offline1: item.status === 0,
                })
                  }, _toDisplayString(item.status === 1 ? "在线" : "离线"), 3)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(item.deviceNo), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("span", null, _toDisplayString(item.driverName), 1)
              ])
            ], 8, _hoisted_11))
          }), 128)),
          (_ctx.towerTable.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "到底了~~"))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, "暂无数据"))
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ])
  ]))
}